import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgFall = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.043 19.016c2.018 1.11 3.983 1.597 5.81 1.477 1.99-.13 3.757-.977 5.187-2.407 2.836-2.836 4.314-7.916 3.887-14.315a.75.75 0 0 0-.698-.699C13.829 2.646 8.75 4.124 5.914 6.96c-1.43 1.43-2.276 3.197-2.407 5.186-.12 1.828.366 3.792 1.476 5.81L3.22 19.719a.75.75 0 1 0 1.06 1.06zm1.11-1.11 3.838-3.837a.75.75 0 0 0-1.061-1.06l-3.837 3.837c-.85-1.672-1.18-3.222-1.09-4.601.106-1.602.78-3.033 1.971-4.224 2.32-2.32 6.647-3.758 12.494-3.49.269 5.848-1.17 10.175-3.489 12.495-1.191 1.19-2.622 1.865-4.224 1.97-1.38.09-2.93-.239-4.602-1.09"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgFall;
